import { AgentTaskStatus } from '~/protos/agents'
import { DiffReview } from '~/store/editorSlice'
import { useTaskObj } from '../../../../hooks/task/useTaskObj'

export interface ReviewHistoryItem {
  review: DiffReview
  ts: number
}

export function useReviewHistory() {
  const taskObj = useTaskObj()
  const tuples =
    taskObj?.details.orderedStateResponses.filter(request => {
      return request.taskStatus === AgentTaskStatus.DIFF_COMMENT_ADDED
    }) ?? []

  const reviewItems: ReviewHistoryItem[] = []
  for (const tuple of tuples) {
    const { request } = tuple as { request: Partial<DiffReview> }
    const item = { review: {} } as ReviewHistoryItem

    item.review.generalDiffComment =
      request.generalDiffComment ?? request?.diffComments?.[0]?.comment ?? 'No general comment'
    item.review.diffComments = request.diffComments ?? []
    item.ts = Number(tuple.createdTsSec) * 1000

    reviewItems.push(item)
  }

  return reviewItems
}
